import React from 'react'

import { DownloadIcon } from '@chakra-ui/icons'
import {
  Avatar,
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import {
  useUpdateUser,
  useUploadUserPicture,
  useUser,
} from '@/react-query/user'
import { LinkedinAvatarFallback } from '@/views/assets/LinkedinAvatarFallback'
import FileUploader from '@/views/components/FileUploader'

export const SelectPictureModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const user = useUser()

  const updateUser = useUpdateUser()

  return (
    <Modal size={'3xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent p={5}>
        <ModalHeader>Edit your picture</ModalHeader>
        <ModalCloseButton />
        <ModalBody display={'flex'} flexDirection={'column'}>
          {user?.data?.photoURL ? (
            <Avatar
              src={user.data.photoURL}
              w={80}
              h={80}
              alignSelf={'center'}
              bg={'transparent'}
              icon={<Box bg={'transparent'} />}
              borderRadius={'2.5rem'}
            />
          ) : (
            <LinkedinAvatarFallback
              h={80}
              w={80}
              alignSelf={'center'}
              borderRadius={'2.5rem'}
            />
          )}

          <HStack
            justifyContent={'center'}
            alignItems={'center'}
            mt={10}
            flexWrap={'wrap-reverse'}
          >
            <UploadNewPicture />
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const UploadNewPicture = () => {
  const uploadUserPicture = useUploadUserPicture()

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async (
    event,
  ) => {
    if (!event.target.files?.[0]) {
      return
    }

    const file = event.target.files?.[0]
    const formData = new FormData()
    formData.append('file', file)
    uploadUserPicture.mutate(formData)
  }

  return (
    <FileUploader
      name="candidatePicture"
      id="candidatePicture"
      acceptedFileTypes=".jpg,.jpeg,.png,.webp,.gif"
      w={20}
      h={20}
      onFileChange={handleFileChange}
      isLoading={uploadUserPicture.isPending}
    >
      <DownloadIcon
        color={'blackAlpha.700'}
        w={5}
        h={5}
        transform="rotate(180deg)"
      />
    </FileUploader>
  )
}
